import React, { useEffect, useState } from "react";

import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";

import { IEditModeValueEditor } from "./Common";
import { UITextList } from "../BuildlingBlocks/UITextList";
import { TextField } from "@mui/material";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

export { DisplayModeValueEditor as DisplayModeStringValueEditor } from "./DisplayModeRender";

export const EditModeStringValueEditor = React.forwardRef<HTMLElement, IEditModeValueEditor>(
    ({ value, forData, onUpdate }: IEditModeValueEditor, ref) => {
        const validValues = (forData as StringDataDefinition).validValues;

        const field = forData.list
            ? Array.isArray(value) && typeof value !== "string"
                ? value
                : value
                  ? [value]
                  : []
            : Array.isArray(value) && typeof value !== "string"
              ? value[0]
              : value;
        const [values, setValues] = useState<AppGlueAny>(field);

        const onValueUpdate = () => {
            if (forData.list) {
                setValues([...field]);
                onUpdate([...field]);
            } else {
                setValues(field);
                onUpdate(field);
            }
        };

        useEffect(() => {
            const getInitialValue = () => {
                return {
                    value: forData.list
                        ? Array.isArray(value) && typeof value !== "string"
                            ? value
                            : value
                              ? [value]
                              : []
                        : Array.isArray(value) && typeof value !== "string"
                          ? value[0]
                          : value,
                };
            };
            setValues(getInitialValue().value);
        }, [value, forData, setValues]);

        if (forData.list) {
            return (
                <UITextList
                    value={field.value}
                    onChange={(v) => {
                        setValues(v);
                        onValueUpdate();
                    }}
                    validValues={validValues}
                />
            );
        } else {
            return (
                <>
                    {validValues && validValues.length > 0 ? (
                        <TextField
                            value={value || ""}
                            onChange={(event: React.ChangeEvent<{ name?: string; value: AppGlueAny }>) => {
                                setValues(event.target.value);
                                onUpdate(event.target.value);
                            }}
                            select
                            SelectProps={{
                                native: true,
                            }}
                            inputProps={{
                                ref,
                            }}
                            data-testid="ValueEditor-Edit-text-withvalids"
                            variant="outlined"
                            size={"small"}
                        >
                            {validValues.map((valid, idx) => (
                                <option
                                    key={`${valid}-${idx}`}
                                    value={valid}
                                >
                                    {valid}
                                </option>
                            ))}
                        </TextField>
                    ) : (
                        <TextField
                            variant={"outlined"}
                            size={"small"}
                            value={values || ""}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setValues(event.target.value);
                            }}
                            inputRef={ref}
                            data-testid="ValueEditor-Edit-text"
                            inputProps={{
                                pattern: (forData as StringDataDefinition).pattern,
                            }}
                            onBlur={() => {
                                onUpdate(values);
                            }}
                            placeholder={forData.name}
                            onKeyDown={(event: React.KeyboardEvent) => {
                                if (event.key === "Enter") {
                                    onUpdate(values);
                                }
                            }}
                        />
                    )}
                </>
            );
        }
    },
);
